import coverageOptionStrToNum from './coverageOptionStrToNum';

export default function calculateClosestVariableOptionEqualOrBelow(
  value: number,
  coverageOptions: string[]
) {
  const options = coverageOptions.map((option) => ({
    value: coverageOptionStrToNum(option as string),
    label: option,
  }));

  const smallestCoverageOption = Math.min.apply(
    null,
    options.map((option) => option.value)
  );

  const greatestLesseqValue = options.reduce(
    (currentLargestValue, { value: coverageValueOption }) => {
      if (
        coverageValueOption <= value &&
        coverageValueOption > currentLargestValue
      ) {
        return coverageValueOption;
      }
      return currentLargestValue;
    },
    smallestCoverageOption
  );

  return options.find((option) => greatestLesseqValue === option.value);
}
